import { Switch, SwitchProps } from '@chakra-ui/react';
import React from 'react';

export const CmSwitch: React.FC<SwitchProps> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <Switch {...rest}>{children}</Switch>;
};
